import { ThemeProvider as MUIThemeProvider } from "@material-ui/core/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { useMemo } from "react";
import { Provider } from "react-redux";

import type { Store } from "redux";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { Authentication } from "./Authentication";
import { Routes } from "./Routes";
import globalCSS from "styles/global";
import { MUI_THEME } from "styles/mui_theme";
import { MAIN_THEME } from "styles/theme";

import type { IUser } from "types/user";

declare global {
  interface Window {
    GLOBAL_USER: IUser;
  }
}

const GlobalStyles = createGlobalStyle`
  ${globalCSS}
`;

export interface RootProps {
  store: Store;
}

const Root = ({ store }: RootProps) => {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 5000 * 60, refetchOnWindowFocus: false },
        },
      }),
    []
  );

  return (
    <MUIThemeProvider theme={MUI_THEME}>
      <ThemeProvider theme={MAIN_THEME}>
        <GlobalStyles />
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <Authentication>
              <Routes />
            </Authentication>
          </Provider>
        </QueryClientProvider>
      </ThemeProvider>
    </MUIThemeProvider>
  );
};

export default Root;
